import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { VacationFormErrors } from '../models/vacation-form-data.interface';
import { VacationWidgetFormType } from '../models/vacation-widget.interfaces';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {
  processErrors(
    errors: VacationFormErrors,
    form: FormGroup<VacationWidgetFormType>,
    hostElement?: HTMLElement
  ): {
    airportErrorMessage: string;
    datesErrorMessage: string;
    tooFewPeopleErrorMessage: string;
    errorCount: number;
    firstErrorElement: HTMLElement | null;
  } {
    return {
      airportErrorMessage: errors.airportError,
      datesErrorMessage: errors.dateError,
      tooFewPeopleErrorMessage: errors.passengerError,
      errorCount: this.countErrors(errors),
      firstErrorElement: this.getFirstInvalidElement(form, hostElement)
    };
  }

  private countErrors(errors: VacationFormErrors): number {
    return [
      errors.airportError,
      errors.dateError,
      errors.passengerError,
      errors.maxDatesError
    ].filter((error) => error && error.trim() !== '').length;
  }

  getFirstInvalidElement(
    form: FormGroup<VacationWidgetFormType>,
    hostElement?: HTMLElement
  ): HTMLElement | null {
    if (!form || form.valid) return null;
    return this.findInvalidControlElement(form, hostElement);
  }

  private findInvalidControlElement(
    form: FormGroup<VacationWidgetFormType>,
    hostElement?: HTMLElement
  ): HTMLElement | null {
    const controls = form.controls;
    const controlMap = [
      {
        check: () =>
          controls.originAirportCode?.invalid ||
          controls.destinationAirportCode?.invalid,
        selector: '.from-and-to'
      },
      {
        check: () =>
          controls.departDate?.invalid || controls.returnDate?.invalid,
        selector: '#max-range-date-trigger'
      },
      {
        check: () => controls.numberOfPassengers?.invalid,
        selector: '.vacation-widget__passenger-selector'
      },
      {
        check: () => controls.numberOfRooms?.invalid,
        selector: '.vacation-widget__room-selector'
      }
    ];

    const invalidControl = controlMap.find((item) => item.check());
    if (!invalidControl) return null;

    const root = hostElement || document;
    return root.querySelector(invalidControl.selector) as HTMLElement;
  }
}
